import React, { createContext, useContext } from "react";
import { Button, Stack, Typography } from "@mui/material";
import { getCareSourceAttribution } from "./careSourceAttribution";
import { formatCareSourceRecordedAt } from "./careSourceStatusModel";

export const CareSourceReviewContext = createContext(null);
const CareSourceByline = ({ source: suppliedSource }) => {
  const contextualSource = useContext(CareSourceReviewContext);
  const source = suppliedSource || contextualSource;
  if (!source) return null;
  const author =
    getCareSourceAttribution(source).authorName || "Author not recorded";
  return (
    <Stack direction="row" spacing={0.75} alignItems="baseline" flexWrap="wrap">
      <Typography sx={{ fontSize: "0.76rem", color: "text.secondary" }}>
        {[author, formatCareSourceRecordedAt(source)]
          .filter(Boolean)
          .join(" · ")}
      </Typography>
      {source.id ? (
        <Button
          component="a"
          href={`/sources/${source.id}`}
          size="small"
          sx={{ p: 0, textTransform: "none" }}
        >
          Open source note
        </Button>
      ) : null}
    </Stack>
  );
};
export default CareSourceByline;
